import SvgIcon from "./IconTrash.svg?react";
const IconTrash = SvgIcon;
export default IconTrash;
